import { render, staticRenderFns } from "./results-number.vue?vue&type=template&id=6d9e166e&"
import script from "./results-number.vue?vue&type=script&lang=ts&"
export * from "./results-number.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports